<template>
    <transition name="slide-fade">
        <div class="modal" :class="{'open' : open}" v-if="open">
            <div class="modal-content relative">
                <div v-if="showLogo" class="bg-white w-full rounded-xl p-4">
                    <div class="w-full flex justify-center items-center">
                        <img src="@/assets/icon/ic-splus.svg" alt="">
                    </div>
                    <div class="text-center text-xl pt-3" v-html="title"></div>
                    <div class="text-center text-22 pb-5 pt-3 font-main-regular text-gray-1" v-html="message"></div>
                    <div class="pb-6" v-if="btnOk && btnOk != ''">
                        <button class="w-full bg-green-1 text-22 text-white rounded-r-full rounded-l-full py-2.5" @click="clickOk()">
                            {{btnOk}}
                        </button>
                    </div>
                    <div class="divider bg-gray-2 w-full mb-4" v-else></div>
                </div>

                <div v-else class="bg-white w-full rounded-xl p-4">
                    <div v-if="type == 'surprise-box'">
                        <img class="-mt-24 w-56 h-40 mx-auto" :src="campaign.fullImageUrl" alt="">
                    </div>
                    <div class="text-center text-30 pt-3 text-blue-1" v-html="title"></div>
                    <div v-if="type == 'surprise-box'" class="surprise-box-content text-22 pb-5 font-main-regular text-gray-1" v-html="message"></div>
                    <div v-else class="text-center text-22 pb-5 pt-3 font-main-regular text-gray-1" v-html="message"></div>
                </div>


                <div class="close-position" @click="clickClose()">
                    <img src="@/assets/icon/ic-close-circle.svg" alt="">
                </div>
            </div>

        </div>
    </transition>

    <transition name="fade">
        <div class="modal-backdrop" v-if="open"></div>
    </transition>
</template>
<script>
import LocaleMixin from "@/mixin/LocaleMixin.js";

export default {
    name: "AlertModal",
    mixins: [LocaleMixin],
    props: {
        controller: Object,
    },
    data: function() {
        return {
            open: false,

            title: '',
            message: '',
            btnOk: '',
            busModal: null,
            showLogo: true,
            type: null,
            campaign: null
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
    },
    mounted: function() {
        this.busModal.on('show', this.show);
        this.busModal.on('hide', this.hide);
    },
    methods: {
        show: function(config) {
            this.title = config.title;
            this.message = config.msg;
            this.btnOk = config.btnOk;
            this.showLogo = config.showLogo;
            this.type = config.type;
            this.campaign = config.campaign;

            document.body.classList.add('not-scroll');
            this.open = true;
        },
        hide: function() {
            document.body.classList.remove('not-scroll');
            this.open = false;
        },
        clickOk: function () {
            this.hide();
            this.controller.sendCallbackOk();
        },
        clickClose: function () {
            this.hide();
            this.controller.sendCallbackClose();
        }
    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/modal.scss";
    .modal {
        @extend %modal;
        overflow: unset;
        // overflow: initial;

        .modal-content {
            overflow: unset;
            // overflow: initial;
        }

        .surprise-box-content {
            max-height: calc(100vh - 320px);
            overflow-y: scroll;
        }

        .divider {
            height: 1px;
        }
        .close-position {
            position: absolute;

            left: 50%;
            transform: translate(-50%, -50%);
        }
    }
</style>
